// extracted by mini-css-extract-plugin
export default {"box":"Footer_box__JxC0B"};